import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {PUT_RESIT_REGISTRATION_REVIEW} from '../../constants/apiUrls';
import {GetSubjectSummaryResponse, ResitSubject} from '../../api/candidate/resit/model';
import {CandidateProfileResponse} from '../../api/candidate/profile/@candidate/models';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface CandidateProfileAndResitResponse {
  subjectSummary: GetSubjectSummaryResponse;
  candidateDetails: CandidateProfileResponse;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: CandidateProfileAndResitResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutCandidateProfileAndResit = ({onSuccess, onError}: Input = {}) => {
  const putCandidateProfileAndResit = async (payload: {
    uuid: string;
    resitSubjects: ResitSubject[];
  }) => {
    const res = await axiosClient.put<CandidateProfileAndResitResponse>(
        PUT_RESIT_REGISTRATION_REVIEW(payload.uuid),
        payload.resitSubjects
    );
    return res.data;
  };

  return useCustomMutation(putCandidateProfileAndResit, {
    onSuccess,
    onError,
  });
};
